import React, { useState, useEffect } from 'react';
import { excelUploadStorage } from '../../services/localStorage.service';
import './ExcelUpload.css';

const ExcelUpload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [importHistory, setImportHistory] = useState([]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    loadHistory();
  }, []);

  const loadHistory = () => {
    const history = excelUploadStorage.getAll();
    setImportHistory(history);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const handleUpload = () => {
    if (selectedFile) {
      setError('');
      setSuccess('');
      
      try {
        const uploadRecord = excelUploadStorage.create({
          fileName: selectedFile.name,
          uploadDate: new Date().toLocaleString('en-IN'),
          status: 'Success',
          fileSize: selectedFile.size,
        });
        
        setSuccess('File uploaded successfully! (Note: Actual import functionality requires file parsing library)');
        setSelectedFile(null);
        loadHistory();
        setTimeout(() => setSuccess(''), 3000);
      } catch (err) {
        setError('Failed to upload file. Please try again.');
      }
    } else {
      setError('Please select a file first');
    }
  };

  return (
    <div className="excel-upload">
      <div className="excel-upload-header">
        <h1 className="page-title">Excel Upload</h1>
        <p className="page-subtitle">Upload your sales and purchases data in Excel format for bulk import.</p>
      </div>

      <div className="excel-upload-content">
        {error && (
          <div style={{ 
            color: '#ef4444', 
            padding: '10px', 
            marginBottom: '15px', 
            backgroundColor: '#fee2e2', 
            borderRadius: '4px',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        {success && (
          <div style={{ 
            color: '#10b981', 
            padding: '10px', 
            marginBottom: '15px', 
            backgroundColor: '#d1fae5', 
            borderRadius: '4px',
            textAlign: 'center'
          }}>
            {success}
          </div>
        )}

        <div className="excel-upload-card">
          <div className="upload-section">
            <label htmlFor="fileInput" className="upload-label">
              Choose Excel File (Sales/Purchases)
            </label>
            <div className="upload-controls">
              <input
                type="file"
                id="fileInput"
                accept=".xlsx,.xls"
                onChange={handleFileChange}
                className="file-input"
              />
              <button onClick={handleUpload} className="btn btn-primary">
                Upload File
              </button>
            </div>
            {selectedFile && (
              <p className="selected-file">Selected: {selectedFile.name}</p>
            )}
            <p className="upload-info">
              Supported formats: .xlsx, .xls. Maximum file size: 10MB. Ensure your Excel file follows the specified template for accurate data import.
            </p>
          </div>
        </div>

        <div className="import-history-card">
          <h2 className="card-title">Import History</h2>
          <table className="table">
            <thead>
              <tr>
                <th>FILE NAME</th>
                <th>UPLOAD DATE</th>
                <th>STATUS</th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {importHistory.length === 0 ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', padding: '20px' }}>
                    No upload history
                  </td>
                </tr>
              ) : (
                importHistory.map((item) => (
                  <tr key={item.id}>
                    <td>{item.fileName}</td>
                    <td>{item.uploadDate}</td>
                    <td>
                      <span className={`status-badge status-${(item.status || 'success').toLowerCase()}`}>
                        {item.status || 'Success'}
                      </span>
                    </td>
                    <td>
                      <button className="view-details-btn">View Details</button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ExcelUpload;

